import withAemIntegration from "../../withAemIntegration";
import loadable from "../../utils/loadable";
const Component = loadable(() =>
  import("@lexus.com/ui/dist/modules/BrochureForm")
);

const BrochureFormEditConfig = {
  emptyLabel: "BrochureForm",
  isEmpty: function (props) {
    return !props || !props.title || props.title.trim().length < 1;
  },
};

const transformData = (props = {}) => {
  return {
    ...props,
    headline: props.commonFields?.heading,
    subHeading: props.commonFields?.subHeading,
    optionalText: props.optionalFieldLabel,
    formLabels: {
      ...props.commonFields,
      ...props.additionalFields,
    },
    mayContact: {
      label: props.dealerOptions?.checkBoxLabel,
      enable: props.dealerOptions?.enableField,
      preferredDealersLabel: props.dealerOptions?.heading,
    },
    lcertifiedOptions: {
      label: props.lcertifiedOptions?.checkBoxLabel,
      value: props.lcertifiedOptions?.checkBoxValue,
      enable: props.lcertifiedOptions?.enableField,
    },
    serverErrorMessaging: {
      errorHeader: props.commonFields?.errorHeading,
      errorDescription: props.commonFields?.errorDescription,
    },
    vehicleSelector: {
      brochureDropdownLabel: props.vehicleSelector?.brochureDropdownLabel,
      brochureDropdownErrorMessage:
        props.vehicleSelector?.brochureDropdownErrorMessage,
      brochureOptions: props.vehicleSelector?.brochureOptions?.map(
        (option) => ({
          label: option.label,
          value: option.brochureCodes.join(","),
          selectionDisabled: option.selectionDisabled,
        })
      ),
    },
    privacyRightsHeading: props.commonFields?.privacyHeading,
    privacyRightsText: props.commonFields?.privacyText,
    submitCta: props.submitCta,
    confirmationHeadline: props.thankYou?.title,
    confirmationSubline: props.thankYou?.message,
    backToBrowseCta: props.thankYou?.backCta,
  };
};

const BrochureForm = (props) => {
  const data = transformData(props);
  return <Component {...data} />;
};

export default withAemIntegration("lexus/components/brochure-form")(
  BrochureForm,
  BrochureFormEditConfig
);
